import { jsxs as e, jsx as n } from "react/jsx-runtime";
import { createContext as r, useState as t, useRef as o, useCallback as c, useEffect as u } from "react";
import { createPortal as l } from "react-dom";
import { ConfirmDialog as i } from "./components/ConfirmDialog.js";
import { useOnKeyPress as s } from "../../hooks/useOnKeyPress/useOnKeyPress.js";
const m = "Ви впевнені, що хочете закрити вікно?", a = "Скасування заповнення форми призведе до втрати внесених даних.", f = "Закрити", d = "Повернутися", p = r(null), b = ({ children: r2 }) => {
  const [b2, h] = t(null), v = o(null), y = o(null), E = o(null), { restoreFocus: F } = b2 || {}, P = c((e2 = {}) => (E.current && E.current(false), new Promise((n2) => {
    E.current = n2, h({ ...e2, onConfirm: () => {
      n2(true), E.current = null;
    } });
  })), []), j = c((e2, n2 = {}) => {
    P(n2).then((n3) => {
      n3 && e2();
    });
  }, [P]), C = c(() => {
    var _a;
    (_a = b2 == null ? void 0 : b2.onConfirm) == null ? void 0 : _a.call(b2), h(null);
  }, [b2]), D = c(() => {
    var _a;
    (_a = E.current) == null ? void 0 : _a.call(E, false), E.current = null, h(null), F == null ? void 0 : F();
  }, [F]), { onKey: K } = s({ enabled: !!b2 });
  u(() => {
    if (!b2) return;
    const e2 = K("Escape", () => D(), { preventDefault: true }), n2 = K("Enter", (e3) => {
      var _a;
      document.activeElement !== (v == null ? void 0 : v.current) && ((_a = y == null ? void 0 : y.current) == null ? void 0 : _a.contains(e3.target)) && (e3.preventDefault(), C());
    });
    return () => {
      e2(), n2();
    };
  }, [K, b2, D, C]);
  const g = (b2 == null ? void 0 : b2.hideSubtitle) ? null : (b2 == null ? void 0 : b2.subtitle) || a;
  return e(p.Provider, { value: { confirm: j, confirmAsync: P }, children: [r2, b2 && l(n(i, { icon: b2.icon, title: b2.title || m, subtitle: g, ref: y, actions: { submit: { caption: b2.submit ?? f, fn: C }, cancel: { caption: b2.cancel ?? d, fn: D, ref: v } }, disableRestoreFocus: !!F, disableEnforceFocus: !!F, disableAutoFocus: !!F }), document.body)] });
};
export {
  p as ConfirmContext,
  b as ConfirmProvider
};
//# sourceMappingURL=ConfirmDialogProvider.js.map
